import icons from 'url:../../img/icons.svg';
// import { AJAX } from '../helpers.js';
// import { API_JWT_BOOTSTRAP_URL } from '../config.js';

class LoginView {
  _parentElement = document.querySelector('.login');
  _loginMessage = document.querySelector('.login__message');
  _loginInput = document.querySelectorAll('.login__input');
  _loginId = document.querySelector('.login__id');
  _loginPassword = document.querySelector('.login__password');
  _togglePassword = document.querySelector('.login__togglepassword');
  _btnForgotPassword = document.querySelector('.login__forgotpassword');
  _errorMessage = 'You have entered a wrong ID or password!';
  _message = 'A password reset link is sent to the registered email ';

  _clearMessage() {
    this._loginMessage.innerHTML = '';
  }

  //To insert and clear the waiting spinner icon while fetching from database
  renderSpinner() {
    const markup = `
	  <div class="login__spinner">
		<svg>
		  <use href="${icons}#icon-loader"></use>
		</svg>
	  </div>
	  `;
    this._clearMessage();
    this._loginMessage.insertAdjacentHTML('afterbegin', markup);
  }

  //To render error message for authentication error
  renderMessage(message = this._message) {
    const markup = `			  
        <p class="emailsent__success-message">${message}</p>`;
    this._clearMessage();
    this._loginMessage.insertAdjacentHTML('afterbegin', markup);
  }
  //To render error message for authentication error
  renderError(message = this._errorMessage) {
    const markup = `			  
    <p class="login__error-message">${message}</p>`;
    this._clearMessage();
    this._loginMessage.insertAdjacentHTML('afterbegin', markup);
  }

  //To remove the login error message once user inputs either ID or password fields
  addHandlerRemoveErrorMessage() {
    this._loginInput.forEach(input =>
      input.addEventListener('input', () => {
        this._clearMessage();
      }),
    );
  }

  //To toggle the visibility of the password when click on the eye icon
  addHandlerTogglePassword() {
    this._togglePassword.addEventListener('click', () => {
      const type =
        this._loginPassword.getAttribute('type') === 'password'
          ? 'text'
          : 'password';
      this._loginPassword.setAttribute('type', type);
      // toggle the icon
      this._togglePassword.classList.toggle('fa-eye-slash');
      this._togglePassword.classList.toggle('fa-eye');
    });
  }

  //To handle login
  addHandlerLogin(handler) {
    this._parentElement.addEventListener('submit', e => {
      e.preventDefault();
      const dataArr = [...new FormData(this._parentElement)]; //get all form data and spread operator into an array. Note that <input> > name is required for this to work.
      const data = Object.fromEntries(dataArr); //convert the array to Object
      handler(data); //pass the data to controller as new login
    });
  }

  //To handle forgot password
  addHandlerForgotPassword(handler) {
    this._btnForgotPassword.addEventListener('click', e => {
      e.preventDefault();
      // To ensure Login ID is entered
      if (this._loginId.value === '') {
        this._errorMessage = 'Please enter Login ID';
        this.renderError();
        return;
      }
      const dataArr = [...new FormData(this._parentElement)]; //get all form data and spread operator into an array. Note that <input> > name is required for this to work.
      const data = Object.fromEntries(dataArr); //convert the array to Object
      handler(data); //pass the data to controller as new login
    });
  }

  // //To handle SSO by receiving the token from the clicked source url and enable access without login
  // addHandlerReceiveToken() {
  //   console.log('[CMS] script loaded');
  //   window.addEventListener('message', async e => {
  //     console.log('[CMS] message received event fired');
  //     console.log('[CMS] origin:', e.origin);
  //     console.log('[CMS] data:', e.data);
  //     const allowDomain = [
  //       'https://edate.trueshape.sg',
  //       'https://sso.trueshape.sg',
  //       'https://shrm.trueshape.sg',
  //     ];

  //     // 🚫 Block unknown origins
  //     if (!allowDomain.includes(e.origin)) {
  //       console.warn('Blocked message from untrusted origin:', e.origin);
  //       return;
  //     }

  //     if (e.data.access) {
  //       console.log('[CMS] access token received');

  //       // ✅ STORE IMMEDIATELY
  //       localStorage.setItem('accesstoken', e.data.access);

  //       console.log('[CMS] token stored');
  //     }

  //     // =========================
  //     // 1. LOGIN / BOOTSTRAP FLOW
  //     // =========================
  //     if (e.data?.logged_in) {
  //       console.log('[CMS] logged_in flag detected');
  //       try {
  //         // 1. store access token from SSO
  //         if (e.data.access) {
  //           localStorage.setItem('accesstoken', e.data.access);
  //           console.log('[CMS] access token saved to localStorage');
  //         } else {
  //           console.warn('[CMS] NO access token in postMessage');
  //         }

  //         console.log('Access token received');

  //         const tokenAfterSave = localStorage.getItem('accesstoken');
  //         console.log(
  //           '[CMS] token after save:',
  //           tokenAfterSave ? 'EXISTS' : 'MISSING',
  //         );

  //         // 2. OPTIONAL bootstrap (refresh / extend session)
  //         const data = await AJAX(
  //           API_JWT_BOOTSTRAP_URL,
  //           localStorage.getItem('accesstoken'),
  //           null,
  //           'GET',
  //         );

  //         console.log('[CMS] bootstrap response:', data);

  //         localStorage.setItem('accesstoken', data.access);

  //         console.log('Bootstrap refresh successful');
  //       } catch (err) {
  //         console.error('Bootstrap failed:', err);

  //         localStorage.removeItem('accesstoken');
  //         localStorage.removeItem('username');

  //         window.location.href = './index.html';
  //       }
  //     }

  //     // =========================
  //     // 2. LOGOUT FLOW (IMPORTANT)
  //     // =========================
  //     else if (e.data === 'logout' || e.data?.logout) {
  //       try {
  //         await AJAX(API_LOGOUT_URL, null, null, 'POST');
  //       } catch (err) {
  //         console.warn('Logout API failed, continuing local cleanup');
  //       }

  //       localStorage.removeItem('accesstoken');
  //       localStorage.removeItem('username');

  //       window.location.href = './index.html';
  //     }

  //     // =========================
  //     // 3. UNKNOWN MESSAGE SAFETY
  //     // =========================
  //     else {
  //       console.warn('Unknown message received:', e.data);
  //     }
  //   });

  // // ✅ Only react to login signal
  // if (e.data.logged_in) {
  //   try {
  //     const token = localStorage.getItem('accesstoken');

  //     if (!token) {
  //       console.warn('No token found in localStorage');
  //       return;
  //     }

  //     // 🔑 Call bootstrap via AJAX (auto-refresh included)
  //     const data = await AJAX(
  //       `${API_JWT_BOOTSTRAP_URL}`,
  //       token,
  //       null,
  //       'GET',
  //     );

  //     // 🔄 Replace with fresh token
  //     localStorage.setItem('accesstoken', data.access);

  //     console.log('Bootstrap token refreshed successfully');
  //   } catch (err) {
  //     console.error('Bootstrap failed:', err);

  // ❗ Optional: force logout if needed
  // localStorage.removeItem('accesstoken');
  // localStorage.removeItem('refreshtoken');
  // localStorage.removeItem('username');

  // window.location.href = './index.html';
  //     }
  //   }
  // });
  // const allowDomain = [
  //   'https://edate.trueshape.sg',
  //   'https://sso.trueshape.sg',
  //   'https://shrm.trueshape.sg',
  // ]; //limit the source url that can poss the token
  // // event listener to postMessage from source url. This has to be loaded first before the postMessage is executed.
  // window.addEventListener('message', e => {
  //   // console.log('test');
  //   // console.log(e.data.accesstoken);
  //   if (allowDomain.includes(e.origin)) {
  //     // check if message is access token then set it to local storage, else remove access token and user name from local storage as it will be "logout" message from logoutView
  //     if (e.data.accesstoken) {
  //       localStorage.setItem(
  //         'accesstoken',
  //         JSON.stringify(e.data.accesstoken)
  //       );
  //       localStorage.setItem('username', JSON.stringify(e.data.username));
  //     } else {
  //       localStorage.removeItem('accesstoken');
  //       localStorage.removeItem('username');
  //       console.warn('Blocked message from untrusted origin:', e.origin);
  //     }
  //   }
  // });
  // }
}
export default new LoginView();
